export default __webpack_public_path__ + "static/media/prize-4-bm.b6312916.webp";